import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const applyTheme = (tema) => {
  document.documentElement.setAttribute("data-theme", tema || "gece");
  document.documentElement.classList.add("dark");
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [kurulum, setKurulum] = useState(null);
  const [ayar, setAyar] = useState(null);

  const loadKurulum = useCallback(async () => {
    const { data } = await api.get("/kurulum/durum");
    setKurulum(data);
    const pub = await api.get("/ayarlar/public");
    applyTheme(pub.data.tema);
    setAyar((a) => ({ ...(a || {}), ...pub.data }));
    return data;
  }, []);

  const loadAyar = useCallback(async () => {
    try {
      await api.post("/kurlar/otomatik").catch(() => {});
      const { data } = await api.get("/ayarlar");
      setAyar(data);
      applyTheme(data.tema);
    } catch (e) {
      // kurulum yapılmamış olabilir
    }
  }, []);

  useEffect(() => {
    (async () => {
      await loadKurulum();
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        if (data.role !== "bayi") await loadAyar();
      } catch {
        setUser(false);
      }
    })();
    const onLogout = () => setUser(false);
    window.addEventListener("erp:logout", onLogout);
    return () => window.removeEventListener("erp:logout", onLogout);
  }, [loadKurulum, loadAyar]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    if (data.role !== "bayi") await loadAyar();
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const isYonetim = user && ["admin", "yonetici"].includes(user.role);

  return (
    <AuthContext.Provider value={{ user, kurulum, ayar, login, logout, loadKurulum, loadAyar, isYonetim }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
